import script from "./ViewMemosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMemosPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewMemosPage.vue?vue&type=style&index=0&id=70b25d8b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b25d8b"]])

export default __exports__